/**
 * @file  routes/config.ts
 * @description  defines the route to component mappings
 * @author ogarcia (ozkary)
 *
 */
import baseRoutes from '../../routes/baseConfig';

/**
 * @description add each route to component mappig below.
 */
const routes = [
  {
    path: ['/', '/login', '/home', '/vehicle', '/mileage'],
    exact: true,
    component: 'Welcome'
  },
  {
    path: ['/coverage'],
    exact: true,
    component: 'Coverages'
  }
];

// export the route mapping
export default routes;
export { baseRoutes };
